import React from 'react';

import { Card, CardContent, Chip, Stack, Typography } from '@mui/material';

import { RateByGroup } from '~/services/cruises/RateGroupService';

interface Props {
  rates: Array<RateByGroup>;
}

function GroupedRateList({ rates }: Props) {
  return (
    <Stack spacing={1}>
      {rates.map((rate) => (
        <Card key={rate.id} variant="outlined">
          <CardContent>
            <Typography fontWeight={700}>{rate.code}</Typography>
            <Typography variant="subtitle2" mt={1}>
              Description
            </Typography>
            <Typography variant="body2">{rate.rateDescription ?? 'Unavailable'}</Typography>
            <Typography variant="subtitle2" mt={1}>
              Current groups
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
              {rate.currentGroups.map((rateGroup) => (
                <Chip key={rateGroup.id} label={rateGroup.name} color="primary" size="small" />
              ))}
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
}

export default GroupedRateList;
